import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import Globe from "react-globe.gl";
import * as THREE from "https://esm.sh/three";

const GlobeComponent = forwardRef(({ position = 'right', onRotationUpdate }, ref) => {
  const globeRef = useRef();

  useImperativeHandle(ref, () => ({
    jumpToLng: (lng) => {
      if (globeRef.current) {
        const pov = globeRef.current.pointOfView();
        globeRef.current.pointOfView({ lat: pov.lat, lng, altitude: pov.altitude }, 0);
      }
    },
  }));
  const [countries, setCountries] = useState({ features: [] });
  const [highlightedCountries, setHighlightedCountries] = useState(new Set());

  useEffect(() => {
    // Load country data
    fetch("https://raw.githubusercontent.com/holtzy/D3-graph-gallery/master/DATA/world.geojson")
      .then((res) => res.json())
      .then(setCountries);
  }, []);

  useEffect(() => {
    // Randomly highlight some countries
    if (countries.features.length > 0) {
      const randomCountries = new Set();
      const numHighlighted = Math.floor(Math.random() * 15) + 5; // 5-20 countries
      
      for (let i = 0; i < numHighlighted; i++) {
        const randomIndex = Math.floor(Math.random() * countries.features.length);
        randomCountries.add(countries.features[randomIndex].properties.NAME);
      }
      
      setHighlightedCountries(randomCountries);
    }
  }, [countries]);

  useEffect(() => {
    if (globeRef.current && countries.features.length > 0) {
      // Enable auto rotation
      globeRef.current.controls().autoRotate = true;
      globeRef.current.controls().autoRotateSpeed = 0.3;
      globeRef.current.controls().enableZoom = false;

      // Set initial camera position - lower altitude = more zoomed in
      globeRef.current.pointOfView({ lat: 0, lng: 0, altitude: 1.8 });
    }
  }, [countries]);

  // Poll rotation angle and notify parent when onRotationUpdate is provided
  useEffect(() => {
    if (!globeRef.current || !onRotationUpdate) return;

    let rafId;
    const pollRotation = () => {
      if (globeRef.current) {
        const pov = globeRef.current.pointOfView();
        if (pov) {
          onRotationUpdate(pov.lng);
        }
      }
      rafId = requestAnimationFrame(pollRotation);
    };
    rafId = requestAnimationFrame(pollRotation);

    return () => cancelAnimationFrame(rafId);
  }, [onRotationUpdate, countries]);

  // // custom globe material
  const globeMaterial = new THREE.MeshPhongMaterial();
  globeMaterial.bumpScale = 10;
  new THREE.TextureLoader().load(
    "//unpkg.com/three-globe/example/img/earth-dark.jpg",
    (texture) => {
      globeMaterial.color = new THREE.Color("#7b1423");
      // globeMaterial.specularMap = texture;
      globeMaterial.specular = new THREE.Color("#af3146");
      globeMaterial.emissive = new THREE.Color("#461517");
      globeMaterial.shininess = 10;
      globeMaterial.fog = false;
      // globeMaterial.shininess = 1;
    }
  );

  // useEffect(() => {
  //   const directionalLight = globeRef.current
  //     .lights()
  //     .find((obj3d) => obj3d.type === "DirectionalLight");
  //   directionalLight && directionalLight.position.set(1, 1, 1); // change light position to see the specularMap's effect
  // }, []);

  return (
    <div
      style={{
        position: "relative",
        overflow: "visible",
        width: "100%",
        height: "100%",
      }}
    >
      <div
        style={{
          position: "absolute",
          overflow: "visible",
          ...(position === 'right' ? { right: "20%" } : { left: "-40%" }),
          top: "0%",
          width: "80%",
          height: "120%",
        }}
      >
        <Globe
          ref={globeRef}
          // Use hexagonal polygons for countries
          hexPolygonsData={countries.features}
          hexPolygonResolution={2}
          hexPolygonMargin={0.12}
          hexPolygonUseDots={false}
          hexPolygonColor={() => "rgba(238, 153, 153, 0.8)"}
          hexPolygonAltitude={(feat) => {
            const countryName = feat.properties.NAME;
            return highlightedCountries.has(countryName) ? 0.005 : 0.001;
          }}
          // globeImageUrl="//unpkg.com/three-globe/example/img/earth-dark.jpg"
          // globeImageUrl={null}
          globeMaterial={globeMaterial}
          // globeMaterial={() => {
          //   const material = new THREE.MeshPhongMaterial({
          //     color: '#a75a5aff',
          //     shininess: 30,
          //     transparent: false,
          //     opacity: 1.0,
          //     side: THREE.FrontSide
          //   });
          //   return material;
          // }}
          showAtmosphere={true}
          atmosphereColor="#cf2323"
          atmosphereAltitude={0.25}
          // hexTopColor={"#C1222A"}
          backgroundColor="#000000"
          width={window.innerWidth * 0.6}
          height={window.innerHeight * 1.1}
          style={{
            transform: 'translateY(50vh)'
          }}
        />
      </div>
    </div>
  );
});

export default GlobeComponent;
